import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function PlomberiePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Plombier Valence | Réparation Fuite, Débouchage, Installation Sanitaire | Ion Certan';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Plombier à Valence : réparation de fuites, débouchage canalisations, installation sanitaire complète. Ion Certan, artisan qualifié avec garantie décennale. Intervention rapide 7j/7 à Valence, Guilherand-Granges, Portes-lès-Valence. Devis gratuit.');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/services/plomberie');
    }
    return () => {
      if (metaDesc) {
        metaDesc.setAttribute('content', 'Plombier Chauffagiste et Sanitaire à Valence. Ion Certan, artisan expert en installation climatisation, chauffage, plomberie et rénovation salle de bains. Intervention rapide à Valence, Bourg-lès-Valence, Guilherand-Granges. Devis gratuit. Noté 5,0 sur Google.');
      }
      if (canonical) {
        canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/');
      }
    };
  }, []);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "Combien coûte une intervention de plomberie à Valence ?",
      answer: "Le tarif dépend de la nature de l'intervention. Nous établissons toujours un devis gratuit avant intervention pour vous informer précisément du coût selon votre situation."
    },
    {
      question: "Intervenez-vous en urgence pour les fuites d'eau ?",
      answer: "Oui, nous intervenons en urgence 7j/7 pour toutes les fuites d'eau à Valence et alentours. Appelez-nous immédiatement au 07 60 70 54 75."
    },
    {
      question: "Quelles marques de sanitaires installez-vous ?",
      answer: "Nous travaillons avec les meilleures marques du marché : Grohe, Hansgrohe, Geberit, Jacob Delafon, Roca et Duravit. Ces équipements offrent qualité, durabilité et garantie constructeur. Nous vous conseillons selon votre budget et vos besoins."
    },
    {
      question: "Proposez-vous un contrat d'entretien pour la plomberie ?",
      answer: "Oui, nous proposons des contrats d'entretien annuels incluant la vérification de vos installations, le détartrage des robinets, le contrôle des joints et flexibles, et une intervention prioritaire en cas de problème. Contactez-nous pour un devis personnalisé."
    },
    {
      question: "Combien de temps dure une installation de salle de bains ?",
      answer: "La durée dépend de la complexité des travaux : dépose de l'ancien, modification de la plomberie, pose du carrelage, installation des sanitaires et finitions. Nous établissons un planning précis avant le début des travaux."
    },
    {
      question: "Êtes-vous assurés et certifiés ?",
      answer: "Oui, nous disposons d'une assurance décennale et responsabilité civile professionnelle. Nos plombiers sont qualifiés et formés aux dernières normes en vigueur. Tous nos travaux sont garantis et conformes aux réglementations."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/7a2352c9962b1cde363ed3f939c1fc60.jpg"
            alt="Plomberie professionnelle à Valence"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-blue-900/70 via-blue-800/60 to-gray-900/70"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center text-white">
          <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-blue-500/20 backdrop-blur-sm border border-blue-400/30 rounded-full mb-4 sm:mb-6">
            <span className="text-xs sm:text-sm font-medium">Plomberie Professionnelle</span>
          </div>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 sm:mb-6 leading-tight">
            Plomberie à Valence
          </h1>
          
          <p className="text-base sm:text-xl md:text-2xl mb-8 sm:mb-10 text-blue-50 max-w-3xl mx-auto leading-relaxed">
            Installation, réparation et dépannage de plomberie par des artisans qualifiés. Intervention rapide et devis gratuit.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-8 sm:mb-12 px-4">
            <a 
              href="tel:+33760705475"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm sm:text-base"
            >
              <i className="ri-phone-fill text-lg sm:text-xl"></i>
              <span>07 60 70 54 75</span>
            </a>
            <a 
              href="mailto:ioncertanpro@gmail.com"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold rounded-lg border-2 border-white/30 transition-all duration-300 whitespace-nowrap text-sm sm:text-base"
            >
              <i className="ri-mail-fill text-lg sm:text-xl"></i>
              <span>Demander un devis</span>
            </a>
          </div>

          <div className="flex flex-wrap gap-4 sm:gap-6 justify-center text-xs sm:text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-blue-400 text-lg sm:text-xl"></i>
              <span>Devis gratuit</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-fill text-blue-400 text-lg sm:text-xl"></i>
              <span>Intervention rapide</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-fill text-blue-400 text-lg sm:text-xl"></i>
              <span>Garantie décennale</span>
            </div>
          </div>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center gap-2 text-xs sm:text-sm text-gray-600">
            <Link to="/" className="hover:text-blue-600 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900 font-medium">Plomberie</span>
          </div>
        </div>
      </div>

      {/* Nos Interventions */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Nos Interventions de Plomberie</h2>
            <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto">
              De la simple réparation à l'installation complète, nous intervenons sur tous types de travaux de plomberie
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="relative h-48 sm:h-64">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20plumber%20repairing%20water%20leak%20under%20modern%20sink%20with%20chrome%20pipes%2C%20close-up%20of%20hands%20using%20wrench%20on%20pipe%20fitting%2C%20water%20droplets%20visible%2C%20clean%20bathroom%20environment%2C%20professional%20repair%20work%2C%20bright%20lighting&width=600&height=400&seq=plomberie-reparation-001&orientation=landscape"
                  alt="Réparation de fuites"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 sm:top-4 left-3 sm:left-4">
                  <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-blue-600 text-white text-xs sm:text-sm font-semibold rounded-full">Urgence</span>
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">Réparation de Fuites</h3>
                <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                  Détection et réparation rapide de toutes fuites d'eau pour éviter les dégâts et surconsommations.
                </p>
                <ul className="space-y-1.5 sm:space-y-2">
                  {['Détection de fuites cachées', 'Réparation robinets et joints', 'Remplacement tuyauterie', 'Intervention sous 2h en urgence'].map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm sm:text-base text-gray-700">
                      <i className="ri-check-line text-blue-600 text-lg sm:text-xl mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className="relative h-48 sm:h-64">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20plumber%20using%20modern%20drain%20cleaning%20equipment%20on%20bathroom%20sink%2C%20spiral%20cable%20tool%20visible%2C%20clean%20white%20bathroom%20with%20chrome%20fixtures%2C%20professional%20service%20work%2C%20bright%20natural%20lighting&width=600&height=400&seq=plomberie-debouchage-001&orientation=landscape"
                  alt="Débouchage canalisations"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 sm:top-4 left-3 sm:left-4">
                  <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-teal-600 text-white text-xs sm:text-sm font-semibold rounded-full">Rapide</span>
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">Débouchage Canalisations</h3>
                <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                  Débouchage professionnel de tous types de canalisations avec équipement haute pression.
                </p>
                <ul className="space-y-1.5 sm:space-y-2">
                  {['Débouchage évier et lavabo', 'Débouchage WC et douche', 'Hydrocurage haute pression', 'Inspection caméra vidéo'].map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm sm:text-base text-gray-700">
                      <i className="ri-check-line text-blue-600 text-lg sm:text-xl mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 sm:col-span-2 lg:col-span-1">
              <div className="relative h-48 sm:h-64">
                <img 
                  src="https://readdy.ai/api/search-image?query=modern%20luxury%20bathroom%20installation%20with%20wall-mounted%20toilet%2C%20floating%20vanity%20with%20chrome%20faucet%2C%20white%20tiles%2C%20contemporary%20design%2C%20professional%20plumbing%20installation%2C%20clean%20bright%20space%2C%20elegant%20fixtures&width=600&height=400&seq=plomberie-installation-001&orientation=landscape"
                  alt="Installation sanitaire"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 sm:top-4 left-3 sm:left-4">
                  <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-gray-800 text-white text-xs sm:text-sm font-semibold rounded-full">Complet</span>
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">Installation Sanitaire Complète</h3>
                <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                  Installation et rénovation complète de salles de bains et cuisines avec équipements haut de gamme.
                </p>
                <ul className="space-y-1.5 sm:space-y-2">
                  {['Pose lavabo, WC, douche, baignoire', 'Installation robinetterie design', 'Raccordement chauffe-eau', 'Rénovation salle de bains clé en main'].map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm sm:text-base text-gray-700">
                      <i className="ri-check-line text-blue-600 text-lg sm:text-xl mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Pourquoi Choisir Notre Service de Plomberie ?</h2>
            <p className="text-base sm:text-xl text-gray-600">Des professionnels qualifiés à votre service</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8">
            {[
              { icon: 'ri-user-star-line', title: 'Plombiers Qualifiés', desc: 'Artisans expérimentés et formés aux dernières techniques de plomberie' },
              { icon: 'ri-time-line', title: 'Intervention Rapide', desc: 'Disponibles 7j/7 pour vos urgences, intervention sous 2h à Valence' },
              { icon: 'ri-price-tag-3-line', title: 'Tarifs Transparents', desc: 'Devis gratuit et détaillé avant intervention, sans surprise' },
              { icon: 'ri-shield-check-line', title: 'Garantie Décennale', desc: 'Tous nos travaux sont garantis et assurés décennale' },
            ].map((item, i) => (
              <div key={i} className="bg-white p-6 sm:p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 group hover:bg-blue-600">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-100 group-hover:bg-white/20 rounded-lg flex items-center justify-center mb-4 sm:mb-6 transition-colors">
                  <i className={`${item.icon} text-2xl sm:text-3xl text-blue-600 group-hover:text-white`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 group-hover:text-white mb-2 sm:mb-3 transition-colors">{item.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 group-hover:text-blue-50 transition-colors">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processus */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Notre Processus d'Intervention</h2>
            <p className="text-base sm:text-xl text-gray-600">Simple, rapide et efficace</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8 relative">
            {[
              { num: '1', title: 'Contact', desc: 'Appelez-nous ou envoyez un email pour décrire votre problème' },
              { num: '2', title: 'Diagnostic', desc: 'Diagnostic gratuit et établissement d\'un devis détaillé' },
              { num: '3', title: 'Intervention', desc: 'Réalisation des travaux par nos plombiers qualifiés' },
              { num: '4', title: 'Garantie', desc: 'Suivi et garantie sur tous nos travaux de plomberie' },
            ].map((step, i) => (
              <div key={i} className="relative text-center">
                <div className="w-14 h-14 sm:w-20 sm:h-20 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl sm:text-3xl font-bold mx-auto mb-4 sm:mb-6 shadow-lg relative z-10">{step.num}</div>
                <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{step.title}</h3>
                <p className="text-xs sm:text-base text-gray-600">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Marques */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Équipements & Marques Installées</h2>
            <p className="text-base sm:text-xl text-gray-600">Nous travaillons avec les meilleures marques du marché</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-8">
            {[
              { name: 'Grohe', rating: 5 },
              { name: 'Hansgrohe', rating: 5 },
              { name: 'Geberit', rating: 5 },
              { name: 'Jacob Delafon', rating: 5 },
              { name: 'Roca', rating: 5 },
              { name: 'Duravit', rating: 5 }
            ].map((brand, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 text-center">
                <div className="text-base sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">{brand.name}</div>
                <div className="flex justify-center gap-0.5 sm:gap-1 text-yellow-400">
                  {[...Array(brand.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs sm:text-base"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contenu SEO */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">Plombier Professionnel à Valence et Alentours</h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Vous recherchez un <strong>plombier qualifié à Valence</strong> pour une installation, une réparation ou un dépannage urgent ? Notre équipe d'artisans plombiers intervient rapidement dans toute la Drôme pour tous vos travaux de plomberie, de la simple fuite d'eau à la rénovation complète de salle de bains.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Nos Services de Plomberie à Valence</h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Forts de nombreuses années d'expérience, nous proposons une gamme complète de services de <strong>plomberie à Valence</strong> : réparation de fuites, débouchage de canalisations, installation de sanitaires, remplacement de robinetterie, pose de chauffe-eau, rénovation de salle de bains et cuisine. Nos plombiers qualifiés utilisent des équipements professionnels et travaillent avec les meilleures marques du marché comme Grohe, Hansgrohe et Geberit.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Dépannage Plomberie Urgent 7j/7</h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Une fuite d'eau, une canalisation bouchée ou un WC qui déborde ? Nous intervenons en urgence <strong>7 jours sur 7 à Valence</strong> et dans toute la Drôme. Notre équipe peut être sur place en moins de 2 heures pour stopper la fuite, limiter les dégâts et effectuer les réparations nécessaires. Appelez-nous immédiatement au 07 60 70 54 75 pour une intervention rapide.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Installation et Rénovation de Salle de Bains</h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Vous souhaitez rénover votre salle de bains ou installer de nouveaux sanitaires ? Nous réalisons des <strong>installations complètes de plomberie à Valence</strong> : pose de douche à l'italienne, installation de baignoire, remplacement de lavabo, pose de WC suspendus, installation de robinetterie design. Nous vous accompagnons de A à Z dans votre projet avec un devis gratuit et des conseils personnalisés sur le choix des équipements.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Pourquoi Choisir Notre Entreprise de Plomberie ?</h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Notre entreprise de <strong>plomberie à Valence</strong> se distingue par son professionnalisme, sa réactivité et la qualité de ses interventions. Tous nos plombiers sont qualifiés, formés aux dernières normes et disposent d'une assurance décennale. Nous proposons des tarifs transparents avec devis gratuit, intervenons rapidement en cas d'urgence et garantissons tous nos travaux. Nos clients à Valence, Guilherand-Granges, Portes-lès-Valence et dans toute la Drôme nous font confiance pour leur plomberie.
            </p>
          </article>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Témoignages Clients</h2>
            <p className="text-base sm:text-xl text-gray-600">Ils nous ont fait confiance pour leur plomberie</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            {[
              { initials: 'LB', name: 'Lucie Bernard', ville: 'Valence', text: 'Intervention très rapide pour une fuite d\'eau sous l\'évier. Le plombier est arrivé en moins d\'une heure, a diagnostiqué le problème et réparé immédiatement. Tarif honnête et travail soigné. Je recommande !' },
              { initials: 'RP', name: 'Romain Petit', ville: 'Guilherand-Granges', text: 'Rénovation complète de notre salle de bains. Travail impeccable, respect des délais et des conseils précieux sur le choix des équipements. L\'équipe est professionnelle et à l\'écoute. Très satisfait du résultat !' },
              { initials: 'AG', name: 'Amandine Girard', ville: 'Portes-lès-Valence', text: 'Débouchage de canalisation un dimanche matin. Malgré le jour férié, l\'intervention a été rapide et efficace. Le plombier a pris le temps d\'expliquer la cause du problème et donné des conseils d\'entretien. Service au top !' },
            ].map((t, i) => (
              <div key={i} className="bg-white p-5 sm:p-8 rounded-xl shadow-md">
                <div className="flex gap-1 text-yellow-400 mb-3 sm:mb-4">
                  {[...Array(5)].map((_, j) => (
                    <i key={j} className="ri-star-fill text-base sm:text-xl"></i>
                  ))}
                </div>
                <p className="text-xs sm:text-base text-gray-700 mb-4 sm:mb-6 italic">"{t.text}"</p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 font-bold text-sm sm:text-lg">{t.initials}</span>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm sm:text-base">{t.name}</div>
                    <div className="text-xs sm:text-sm text-gray-600">{t.ville}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Questions Fréquentes</h2>
            <p className="text-base sm:text-xl text-gray-600">Tout ce que vous devez savoir sur nos services de plomberie</p>
          </div>

          <div className="space-y-3 sm:space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-50 rounded-xl overflow-hidden border border-gray-200">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors"
                >
                  <span className="font-semibold text-gray-900 pr-4 sm:pr-8 text-sm sm:text-base">{faq.question}</span>
                  <i className={`ri-arrow-${openFaq === index ? 'up' : 'down'}-s-line text-xl sm:text-2xl text-blue-600 flex-shrink-0`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-4 sm:px-6 pb-4 sm:pb-5">
                    <p className="text-xs sm:text-base text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="relative py-16 sm:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=professional%20plumber%20team%20standing%20in%20modern%20clean%20workshop%20with%20organized%20tools%20and%20equipment%2C%20bright%20professional%20environment%2C%20chrome%20pipes%20and%20fixtures%20visible%2C%20team%20of%20skilled%20craftsmen%2C%20welcoming%20atmosphere&width=1920&height=600&seq=plomberie-cta-final-001&orientation=landscape"
            alt="Contactez-nous"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-700/90"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center text-white">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">Besoin d'un Plombier à Valence ?</h2>
          <p className="text-base sm:text-xl mb-8 sm:mb-10 text-blue-50">
            Contactez-nous pour un devis gratuit ou une intervention rapide
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <a 
              href="tel:+33760705475"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-white text-blue-600 hover:bg-blue-50 font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm sm:text-base"
            >
              <i className="ri-phone-fill text-lg sm:text-xl"></i>
              <span>07 60 70 54 75</span>
            </a>
            <a 
              href="mailto:ioncertanpro@gmail.com"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg border-2 border-white/30 transition-all duration-300 whitespace-nowrap text-sm sm:text-base"
            >
              <i className="ri-mail-fill text-lg sm:text-xl"></i>
              <span>ioncertanpro@gmail.com</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}